module.exports = __webpack_public_path__ + "static/img/bathroom.da48032.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/bathroom.jpg
// module id = Ac1N
// module chunks = 0